import React from "react";
export default function SignUpFinish() {
  return <h1>SignUpFinish</h1>;
}
